export const layoutHtml = (state, translationService, getSiteName) => {
  const { siteSettings, deviceOptions } = state;

  if (!siteSettings || siteSettings.length === 0) {
    return `
      <div class="no-data">
        <p>${translationService.translate('usersView.noSitesAssigned')}</p>
      </div>
    `;
  }

  const tableRows = siteSettings.map(siteSetting => {
    const siteName = getSiteName(siteSetting.siteId);
    const siteId = siteSetting.siteId;

    // Get available printers for this site
    const generalPrinters = deviceOptions.defaultPrinterId[siteId] || [];
    const receiptPrinters = deviceOptions.defaultReceiptPrinterId[siteId] || [];
    const atjPrinters = deviceOptions.defaultAtjPrinterId[siteId] || [];

    const createPrinterSelect = (printers, selectedValue, printerType) => {
      const options = [
        `<option value="">${translationService.translate('select')}</option>`,
        ...printers.map(printer => 
          `<option value="${printer.id}" ${selectedValue === printer.id ? 'selected' : ''}>${printer.name}</option>`
        )
      ].join('');

      return `
        <select 
          data-site-id="${siteId}" 
          data-printer-type="${printerType}"
          class="printer-select"
        >
          ${options}
        </select>
      `;
    };

    return `
      <tr>
        <td class="site-name" primary-column>${siteName}</td>
        <td class="printer-select-cell">
          ${createPrinterSelect(generalPrinters, siteSetting.defaultPrinterId, 'defaultPrinterId')}
        </td>
        <td class="printer-select-cell">
          ${createPrinterSelect(receiptPrinters, siteSetting.defaultReceiptPrinterId, 'defaultReceiptPrinterId')}
        </td>
        <td class="printer-select-cell">
          ${createPrinterSelect(atjPrinters, siteSetting.defaultAtjPrinterId, 'defaultAtjPrinterId')}
        </td>
      </tr>
    `;
  }).join('');

  return `
    <div class="default-printers-container">
      <div class="table-container">
        <table class="printers-table">
          <thead>
            <tr>
              <th class="site-header">${translationService.translate('myInfoView.name')}</th>
              <th class="printer-header">${translationService.translate('myInfoView.defaultPrinter')}</th>
              <th class="printer-header">${translationService.translate('myInfoView.defaultReceiptPrinter')}</th>
              <th class="printer-header">${translationService.translate('myInfoView.defaultPrinterAtj')}</th>
            </tr>
          </thead>
          <tbody>
            ${tableRows}
          </tbody>
        </table>
      </div>
      <div class="buttons-container">
        <button class="primary" id="button-save"></button>
        <button id="button-cancel"></button>
      </div>
    </div>
  `;
};